var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Icon as ChakraIcon } from "@chakra-ui/react";
import { Size, Spacing } from "../../core";
import IconMap from "./IconMap";
export const IconSize = Size;
/**
 * Use the `<Icon>` component to easily render `<svg>` icons.
 */
function Icon(_a) {
    var _b;
    var { className, icon, color, size, as, spacing = Spacing[2] } = _a, rest = __rest(_a, ["className", "icon", "color", "size", "as", "spacing"]);
    return (React.createElement(ChakraIcon, Object.assign({ fontSize: size, className: className, name: icon, color: color, mr: spacing, ml: spacing, as: (_b = as) !== null && _b !== void 0 ? _b : (icon ? IconMap[icon] : undefined) }, rest)));
}
Icon.displayName = "Icon";
export default Icon;
//# sourceMappingURL=Icon.js.map